export default {
    loyalty_products: [],
}